export { fetchAllUpgradePointsRpc, getUpgradeConfigWithPurchaseMotionsRpc, postUpgradePointInteractionRpc } from './UpgradeManagementService-v1/operations';